import { carFormFields as cFields } from '@/utils/dictionaries/carForm'

/**
 * Prepare form fields to send api.
 *
 * @param {FormData} f
 * @returns {FormData}
 */
export default function normalize(f) {
  const g = (field) => f.get(field)

  if (g(cFields.year) && g(cFields.make) && g(cFields.model)) {
    f.set('title' , `${g(cFields.year)} ${g(cFields.make)} ${g(cFields.model)}`)
  }

  if (g(cFields.country === 'US')) {
    f.set('location' , `${g(cFields.titleState)}, ${g(cFields.zipCode)}`)
  } else if (g(cFields.country === 'CA')) {
    f.set('location' , `${g(cFields.cityAndProvince)}`)
  }

  f.set('reserve' , `${g(cFields.reserve) === 'true' ? 1 : 0}`)
  f.set(cFields.ownerHasTitle, `${g(cFields.reserve) === 'true' ? 1 : 0}`)

  return f
}

